import { keyframes } from 'styled-components';
var animatedBlock = keyframes(["0%{opacity:0.6;transform:translateY(4rem) scale(0.9);}100%{opacity:1;transform:none;}"]);
export { animatedBlock };